import { Trans } from '@lingui/react/macro'
import { Card, Divider, Tag } from '@tecsinapse/cortex-react'
import React from 'react'
import { FaRegCalendarAlt } from 'react-icons/fa'
import { GoPaperclip } from 'react-icons/go'
import { MdOutlineMail } from 'react-icons/md'
import { Link } from 'react-router-dom'
import { i18n } from '@/i18n'
import { formatRouteForPush, Routes } from '@/core/router/routes'
import { itemFooter } from '@/core/styles/item-footer'
import { cardComunicado, tag } from '../styles/comunicado-envio-home'

export type Comunicado = {
  lido: boolean
  comunicado: {
    id: string
    titulo: string
    envioDateTime: Date
    usuarioCriador: {
      email: string
    }
    arquivos: any[]
  }
}

interface HomeContentBoxProps {
  comunicadoEnvio: Comunicado
}

const { container, icon, span } = itemFooter()

export const ComunicadoEnvioHomeCellCortex = ({
  comunicadoEnvio
}: HomeContentBoxProps) => {
  const { comunicado, lido } = comunicadoEnvio
  const {
    arquivos,
    envioDateTime,
    id,
    titulo,
    usuarioCriador: { email }
  } = comunicado

  const linkVisualizacao = formatRouteForPush(
    Routes.COMUNICADO_ENVIO_VISUALIZACAO,
    [id]
  )

  return (
    <Link to={linkVisualizacao} className={'no-underline decoration-black'}>
      <Card className={cardComunicado({ read: lido })}>
        <div className='flex justify-between items-center p-deca'>
          <div className='flex flex-row gap-x-mili mr-kilo truncate'>
            <Tag.Face className={tag({ read: lido })}>
              <Tag.Label>
                {lido ? <Trans>Lido</Trans> : <Trans>Não lido</Trans>}
              </Tag.Label>
            </Tag.Face>
            <p className='font-bold text-h3 min-auto truncate text-black'>
              {titulo}
            </p>
          </div>
        </div>
        <Divider />
        <div className='px-deca pb-deca pt-mili flex flex-col lg:flex-row items-start lg:itens:center lg:space-x-kilo'>
          <div className={container()}>
            <MdOutlineMail className={icon({ className: 'mt-[2px]' })} />
            <p className='font-bold'>{email}</p>
          </div>
          <div className={container()}>
            <FaRegCalendarAlt className={icon()} />
            <p>
              <span className={span()}>
                <Trans>Publicação: </Trans>{' '}
              </span>
              {i18n.date(envioDateTime, {
                dateStyle: 'short',
                timeStyle: 'short'
              })}
            </p>
          </div>
          <div className={container()}>
            <GoPaperclip className={icon()} />
            <p>
              <span className={span()}>
                <Trans>Anexos:</Trans>{' '}
              </span>
              {arquivos.length}
            </p>
          </div>
        </div>
      </Card>
    </Link>
  )
}
